module.exports = __webpack_public_path__ + "static/img/30018 (3).0f6be98.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30018 (3).webp
// module id = +yLe
// module chunks = 14